import {
    IEntity,
    IEntityAttribute,
    IEntityAttributeSearchOptions,
    IEntityCreateOptions, IEntityManager
} from "../PA.MD.Core/PA.MD.IF.Entity";
import * as _ from "lodash"
import {
    WB_AttributeTypeRow
} from "../PA.Core/PAdbSchemaRows";
import {IDateRange, IMessageProvider, IProgressProvider, MessageType} from "../PA.Core/PA.Core.IF.Basic";
import {DateUtils} from "../PA.Core/Basic/Dates";
import {ProgressProvider} from "../PA.Core/Basic/Progress";
import {IHierarchyStructureNavigator} from "../PA.MD.Core/PA.MD.IF.Hierarchy";
import {MessageProvider} from "../PA.Core/Basic/Messages";
import {HierarchyStructureManager} from "../PA.MD.Hierarchy/HierarchyStructureManager";
import {HierarchyHarness} from "../PA.MD.Hierarchy/HierarchyHarness";
import {PAdbContext} from "../PA.Core/PAdbContext";
import {EntityManagerFactory} from "./EntityManagerFactory";


import {HierarchyStructureNavigator} from "../PA.MD.Hierarchy/HierarchyStructureNavigator";


export class EntityUtils {

    static async ValidateCustomAttributes(entity: IEntity) {
        if (_.isEmpty(entity))
            return

        //-- Create dictionary for splitting validations for each type.
        let dct: { [wbAttributeMId: number]: IEntityAttribute[] } = {}
        let dctType: { [wbAttributeMId: number]: WB_AttributeTypeRow } = {}

        _.forEach(entity.EntityAttributes, (ea) => {
            if (ea.bDeleted)
                return

            if (_.isEmpty(ea.type))
                return

            if (ea.type.bCoreInd)
                return

            let wbAttributeMId = ea.type.cif.WB_ATTRIBUTEM_ID
            if (!(wbAttributeMId in dctType))
                dctType[wbAttributeMId] = ea.type

            if (!(wbAttributeMId in dct))
                dct[wbAttributeMId] = []

            dct[wbAttributeMId].push(ea)
        })

        //-- Validate, use metadata to determine sales area, etc.
        _.forEach(dct, (arrEA, wbAttrMId) => {
            let attrType = dctType[<any>wbAttrMId]
            let typeId = attrType.cif.ATTRIBUTEM_ID
            let typeName = attrType.cif.ATTRIBUTEM_NAME

            // Check for duplicate in simple attributes,
            //   no sales area, no effective dates
            if ((!attrType.bSalesAreaInd) && (!attrType.bEffectiveDateInd)) {
                if (arrEA.length > 1) {
                    let msgTxt = `Attribute ${typeName} has multiple (${arrEA.length}) values.`
                    entity.ValidateMessageProvider.addMessage({
                        code: `Duplicate-${typeId}`,
                        type: MessageType.Error,
                        title: msgTxt,
                        description: msgTxt
                    })
                }
                return
            }

            // Check for duplicate in simple attributes,
            //   no sales area, effective dates
            if ((!attrType.bSalesAreaInd) && (attrType.bEffectiveDateInd)) {
                EntityUtils.checkDatesAndOverlap(entity, attrType, arrEA, {})
                return
            }

            // Check for duplicate
            if (attrType.bSalesAreaInd) {
                // create dictionary, by Sales Area
                let dctSA: { [wbSalesAreaId: number]: IEntityAttribute[] } = {}
                _.forEach(arrEA, (ae) => {
                    let wbSalesAreaId = ae.wbSalesAreaId
                    if (!(wbSalesAreaId in dctSA))
                        dctSA[wbSalesAreaId] = []

                    dctSA[wbSalesAreaId].push(ae)
                })

                _.forEach(dctSA, (arr, wbSalesAreaId) => {
                    if (attrType.bEffectiveDateInd) {
                        EntityUtils.checkDatesAndOverlap(entity, attrType, arr, {wbSalesAreaId: +wbSalesAreaId})
                    } else {
                        if (arr.length > 1) {
                            let msgTxt = `Attribute ${typeName} has multiple (${arrEA.length}) values for the same Sales Area.`
                            entity.ValidateMessageProvider.addMessage({
                                code: `Duplicate-${wbSalesAreaId}-${typeId}`,
                                type: MessageType.Error,
                                title: msgTxt,
                                description: msgTxt
                            })
                        }
                    }
                })

                return
            }


        })


    }

    private static checkDatesAndOverlap(entity: IEntity, attrType: WB_AttributeTypeRow, arrEAs: IEntityAttribute[], info?: { wbSalesAreaId?: number }) {

        let bDateErrorFound = false
        let mp = entity.ValidateMessageProvider

        let eaName = attrType.cif.ATTRIBUTEM_NAME

        _.forEach(arrEAs, (ea) => {
            let range = ea.effectiveRange
            let startDate = range?.StartDt
            let endDate = range?.EndDt
            if ((!_.isDate(startDate)) || (!_.isDate(endDate))) {
                bDateErrorFound = true
                let msg = `Invalidate Date Range in ${eaName}`
                mp.addMessage({
                    code: `InvalidateDate-${eaName}`,
                    type: MessageType.Error,
                    title: msg,
                    description: msg
                })
            } else {
                // Check Date Order
                if (startDate.getTime() > endDate.getTime()) {
                    bDateErrorFound = true
                    let msg = `Invalidate Date Order in ${eaName}: ${DateUtils.formatDate(startDate)} - ${DateUtils.formatDate(endDate)}`
                    mp.addMessage({
                        code: `InvalidDateOrder-${eaName}`,
                        type: MessageType.Error,
                        title: msg,
                        description: msg
                    })
                }
            }
        })

        // Don't check overlap with invalid dates
        if (bDateErrorFound)
            return

        // Sort Attributes, and check for Overlap
        let sorted = _.sortBy(arrEAs, (a) => a.effectiveRange.StartDt)
        let startDt: Date
        let endDt: Date

        let arrOvrlpRange: string[] = []
        _.forEach(sorted, (ae, idx) => {
            if (idx == 0) {
                startDt = ae.effectiveRange.StartDt
                endDt = ae.effectiveRange.EndDt
                return
            }
            let start = ae.effectiveRange.StartDt
            let end = ae.effectiveRange.EndDt
            //--
            if (DateUtils.RangeDatesOverlap(startDt, endDt, start, end)) {
                arrOvrlpRange.push(`[${DateUtils.formatDate(startDt)}, ${DateUtils.formatDate(endDt)}] - [${DateUtils.formatDate(start)}, ${DateUtils.formatDate(end)}]`)
            }

        })

        if (arrOvrlpRange.length) {
            mp.addMessage({
                code: `DateOverlap-${info?.wbSalesAreaId || 0}-${eaName}`,
                type: MessageType.Error,
                title: `${eaName} has overlapping date ranges. (${arrOvrlpRange.length})`,
                description: arrOvrlpRange.join("\n")
            })
        }

    }

    // Reusable version for all entities
    static searchAttributes(entity: IEntity,
                            pEAs: IEntityAttribute[],
                            options?: IEntityAttributeSearchOptions)
        : IEntityAttribute {
        if (_.isEmpty(entity) || _.isEmpty(pEAs))
            return undefined

        let opts = options || {}
        let type = pEAs[0].type

        let arrEAs: IEntityAttribute[] = pEAs
        if (type.bEffectiveDateInd) {
            let ovrlpRange: IDateRange = {
                StartDt: opts.effectiveStartDt,
                EndDt: opts.effectiveEndDt
            }
            // Find first Effective Overlap
            arrEAs = _.filter(arrEAs, (a) => {
                return DateUtils.RangesOverlap(ovrlpRange, a.effectiveRange)
            })
        }
        //--
        if (!type.bSalesAreaInd && !type.bEffectiveDateInd) {
            return _.first(arrEAs)
        }

        let foundEAs: IEntityAttribute[] = []
        if (type.bSalesAreaInd) {
            //
            for (let wbSalesAreaId of opts.wbSalesAreaIds || []) {
                let saEAs = _.filter(arrEAs, (a) => (a.wbSalesAreaId == wbSalesAreaId))
                if (saEAs.length)
                    foundEAs.push(_.first(saEAs))
            }

            // Check if the values match ?
            if (foundEAs.length > 1) {
                if (opts.chooseFirst)
                    return _.first(foundEAs)

                // Do more advance check in the future, choose first for now
                return _.first(foundEAs)
            } else
                return _.first(foundEAs)
        }

        return undefined
    }

}